// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__tKMyr","errors":"Errors_errors__J1faY"};